import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectProfileBusy, selectUserAvatar } from '../../../store/profile/profile.state';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-profile-avatar',
    templateUrl: './profile-avatar.component.html',
    styleUrls: ['./profile-avatar.component.scss'],
    imports: [NgClass, AsyncPipe]
})
export class ProfileAvatarComponent implements OnInit {

  constructor(private store: Store<AppState>) { }

  profileAvatar$ = this.store.select(selectUserAvatar);
  profileBusy$ = this.store.select(selectProfileBusy);

  ngOnInit(): void {
  }

}
